// extracted by mini-css-extract-plugin
export var link = "hv_S";